import { render } from "./GoBackUtil.vue?vue&type=template&id=3d0dea7e"
import script from "./GoBackUtil.vue?vue&type=script&lang=js"
export * from "./GoBackUtil.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__